import testimage from '../../images/57logo.jpeg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faHashtag, faEnvelope, faPhoneVolume } from '@fortawesome/duotone-light-svg-icons'
const TestStaffAdd = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <div className="card">
                            <div className="card-image-top" style={{ position: 'relative' }}>
                                <div className="imagecontainer w-80 h-80 p-2" style={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '30%',
                                    transform: 'translate(-50%, -50%)', // This will center the image both horizontally and vertically
                                    border: '5px solid white',
                                    borderRadius: '50%',
                                    backgroundColor:'thistle'
                                }}>
                                    <img src={testimage} alt="" className="img-fluid w-100" style={{ borderRadius: '50%' }} />
                                </div>

                                <div className="text-center" style={{ marginTop: '100px' }}>
                                    <div className="row"><h5 className='h5'>TEST NAME</h5></div>
                                    <div className="row"><h6 className='h6'>CEO</h6></div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="body border border-2-black p-2 justify-content-center" style={{ backgroundColor: 'ButtonFace' }}>
                                    <div className="row">
                                        <div className="col-2 ">
                                            {/* <FontAwesomeIcon icon={faHashtag} /> */}
                                        </div>
                                        <div className="col-10"> 121233</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-2">
                                            {/* <FontAwesomeIcon icon={faEnvelope} /> */}
                                        </div>
                                        <div className="col-10"> test@gmai.com</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-2">
                                            {/* <FontAwesomeIcon icon={faPhoneVolume} /> */}
                                        </div>
                                        <div className="col-10"> 8976568766</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default TestStaffAdd;